module.exports = __webpack_public_path__ + "img/Icon-Healthcare_Visits.5bbac1a0.svg";